import { render, staticRenderFns } from "./ReceptionDetails.vue?vue&type=template&id=c093e91e&lang=pug&"
import script from "./ReceptionDetails.vue?vue&type=script&lang=js&"
export * from "./ReceptionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports